import React from 'react'
import { Tag, Tooltip } from 'antd'

export interface ScheduleStatusRecord {
  success_status?: string | null
  extra_data?: any
}

export type ScheduleStatusColor = 'default' | 'success' | 'error' | 'processing'

export function getScheduleStatus(record: ScheduleStatusRecord): {
  color: ScheduleStatusColor
  label: string
  reason: string | null
} {
  const raw = record.success_status
  if (!raw) return { color: 'default', label: 'Unknown', reason: null }

  const lowered = raw.toLowerCase()
  if (lowered.includes('fail')) {
    return { color: 'error', label: 'Failed', reason: record.extra_data?.error ?? null }
  }
  if (lowered.includes('sent')) return { color: 'success', label: 'Sent', reason: null }
  if (lowered.includes('success') || lowered.includes('scheduled')) {
    return { color: 'success', label: 'Scheduled', reason: null }
  }
  return { color: 'processing', label: raw, reason: null }
}

export default function ScheduleStatusCell({ record }: { record: ScheduleStatusRecord }) {
  const { color, label, reason } = getScheduleStatus(record)
  const tag = <Tag color={color}>{label}</Tag>
  return reason ? <Tooltip title={reason}>{tag}</Tooltip> : tag
}
